import { Button } from "@mui/material";
import colors from "../../theme/themeConstants";

interface IProp {
  img: string;
  imgSize?: string;
  bgColor?: string;
  border?: string;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

const GrayRoundButton = ({ img, imgSize, bgColor, border, onClick }: IProp) => {

  return (
    <Button
      onClick={onClick}
      sx={{
        backgroundColor: bgColor || colors.lightGray_GoBackButton,
        border: border || `2px solid ${colors.lightGray_GoBackButton}`,
        height: "36px",
        minWidth: "36px",
        width: "36px",
        borderRadius: "25px",
        zIndex: 24,
        "& img": {
          maxHeight: imgSize || "12px",
          padding: "1px",
        }
      }}>
      <img src={img} alt="Back" />
    </Button>
  );
};

export default GrayRoundButton;
